import { DocumentDto, AnswerModel } from '@bo-client/shared/models/documentDto';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import { UserDto } from '@shared/models';
import { InstallerPassStatusType } from '@bo-client/technician-management/tm-user/tm-user.model';
import { ActivityDto } from '@bo-client/shared/models/activityDto';

export interface InstallerPassDto {
  id?: number;
  documents?: DocumentDto[];
  companylocation?: CompanyLocationDto;
  idarea?: number;
  status?: InstallerPassStatusType;
  applicationdate?: Date;
  expirationdate?: Date;
  approvedByInstallerCommittee?: boolean;
  shortDescription?: string;
}

export class InstallerPassModel {
  id?: number;
  externalId?: string = '';
  passNummer?: string = '';
  networkOperator?: number;
  idarea?: number;
  status?: InstallerPassStatusType;
  requestRenovation?: boolean;

  type?: string;
  applicationdate?: Date = new Date();
  approvedByInstallerCommittee?: boolean;
  expirationdate?: Date;
  user?: UserDto;
  companylocation?: CompanyLocationDto;
  answers?: AnswerModel[];
  version?: number;
  activities?: ActivityDto[];
  shortDescription?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  createdBy?: string;
  lastModifiedBy?: string;
  referenceId?: string;
}

export class CreateInstallerPassModel {
  id?: number;
  passNummer?: string;
  idarea?: number;
  status?: string;
  type?: string;
  applicationdate?: Date = new Date();
  expirationdate?: Date;
  userId?: number;
  companylocation?: CompanyLocationDto;
  answers?: AnswerModel[];
  shortDescription?: string;
}

export class AuxInstallerPassModel {
  auxDocTotal: number;
  auxDocLoaded: number;
  auxPorcLoaded: number;
  pass: InstallerPassModel;
}

export enum InstallerStatusEnum {
  Initialized = 'Initialized',
  PendingDocuments = 'PendingDocuments',
  DocumentsComplete = 'DocumentsComplete',
  RequestValidation = 'RequestValidation',
  ReadyToValidate = 'ReadyToValidate',
  Valid = 'Valid',
  Invalid = 'Invalid',
  Expired = 'Expired',
  RequestRenew = 'RequestRenew',
  FeedbackNeeded = 'FeedbackNeeded'
}

export enum InstallerPassTypeEnum {
  pass = 'pass',
  license = 'license'
}

export const InstallerPassTypeDisplayName = {
  [InstallerPassTypeEnum.pass]: 'Installateurausweis',
  [InstallerPassTypeEnum.license]: 'Gastgenehmigung'
};

export enum InstallerPassExpiredTypeEnum {
  pass = 'pass', // then-contract
  license = 'license', // Gast-validation
  renew = 'renew', // Renew Installer Pass or licence
  renewPass = 'renewPass', // Renew Installer Pass
  renewLicense = 'renewLicense' // Renew licence Installer Pass
}

export enum DocumentTypeEnum {
  doc = 'doc', // doc for pass or license
  question = 'question', // question for pass or license
  license = 'license', // license for license
  renewDocument = 'renewDocument', // doc for renew pass or license
  renewQuestion = 'renewQuestion' // quuestion for renew pass or licence
}
